// Where does a tap on an Ad Center banner go, on the web?
//
// One place for the rule, shared by the desktop and mobile-web hero slides.
// Mirrors app/utils/bannerDispatcher.js in the Expo and iOS apps: the same
// Advertisement row must land on the same page from every surface.
//
// Returns null when the banner is just a picture, or when a legacy row has
// no destination the web can resolve (e.g. an old `product` row saved before
// the server started stamping `linkParams.path`).
//   { kind: "category", value: "<category name>" }  → shop filtered by category
//   { kind: "link",     value: "/path" | "https://…" } → SPA push or new tab

const VENDOR_PATHS = {
  brand: (id) => `/brand/shop/${id}`,
  restaurant: (id) => `/restaurant/shop/${id}`,
  retail: (id) => `/shop/${id}`,
  healthcare: (id) => `/healthcare/shop/${id}`,
};

export const resolveBannerDestination = (slide) => {
  if (!slide) return null;
  const type = slide.linkType || "none";
  const target = String(slide.linkTarget || "").trim();
  const params = slide.linkParams || {};

  if (type === "category") {
    const value = target || slide.categoryName || "";
    return value ? { kind: "category", value } : null;
  }
  if (type === "external") {
    const value = target || slide.externalLink || "";
    return value ? { kind: "link", value } : null;
  }
  if (type === "product") {
    if (params.path) return { kind: "link", value: params.path };
    // Older rows: only a brand product can be rebuilt safely, because that
    // page needs both ids. Anything else has no cold-load-safe destination.
    if (params.kind === "brand" && params.vendorId && target) {
      return { kind: "link", value: `/brand/shop/${params.vendorId}/product/${target}` };
    }
    return null;
  }
  if (type === "vendor") {
    if (params.path) return { kind: "link", value: params.path };
    const build = VENDOR_PATHS[params.kind];
    return build && target ? { kind: "link", value: build(target) } : null;
  }
  return null;
};

export const bannerIsClickable = (slide) => !!resolveBannerDestination(slide);
